{
  "app": {
    "loading": {
      "title": "myDATA Comply",
      "subtitle": "Προετοιμασία…"
    },
    "tabs": {
      "dashboard": "Επισκόπηση",
      "submissions": "Υποβολές",
      "configuration": "Ρυθμίσεις"
    }
  },
  "welcome": {
    "title": "Καλώς ήρθατε στο myDATA Comply!",
    "subtitle": "Ευχαριστούμε που εγκαταστήσατε την εφαρμογή μας. Ας ρυθμίσουμε τις αυτόματες υποβολές σας στο myDATA.",
    "whatYouGet": {
      "title": "Τι περιλαμβάνεται:",
      "trial": "7 δωρεάν υποβολές για δοκιμή",
      "automation": "Αυτόματη υποβολή παραστατικών στο myDATA (ΑΑΔΕ)",
      "pdfGeneration": "Δημιουργία PDF με QR code και λογότυπο",
      "realTimeTracking": "Παρακολούθηση υποβολών & ιστορικό σε πραγματικό χρόνο",
      "support": "Τεχνική υποστήριξη εντός 24 ωρών"
    },
    "nextSteps": {
      "title": "Πώς ξεκινάτε (3 απλά βήματα):",
      "step1": "Πηγαίνετε στις Ρυθμίσεις και συμπληρώστε τα στοιχεία της επιχείρησής σας (ΑΦΜ, επωνυμία, διεύθυνση)",
      "step2": "Μόλις αποθηκεύσετε, λαμβάνουμε τα στοιχεία σας και ξεκινάμε τη διαδικασία ενεργοποίησης του παρόχου",
      "step3": "Εντός ~1 εργάσιμης ημέρας, θα λάβετε ψηφιακό αίτημα εξουσιοδότησης από τον επίσημο πάροχο — αποδεχτείτε το και είστε έτοιμοι!"
    },
    "action": {
      "configure": "Πήγαινε στις Ρυθμίσεις",
      "goToDashboard": "Πήγαινε στην Επισκόπηση"
    }
  },
  "submissions": {
    "title": "Ιστορικό Υποβολών",
    "subtitle": "Προβολή όλων των υποβολών myDATA",
    "totalCount": "{count} συνολικά",
    "columns": {
      "order": "Παραγγελία",
      "type": "Τύπος",
      "date": "Ημ/νία Υποβολής",
      "status": "Κατάσταση",
      "mark": "ΜΑΡΚ",
      "pdf": "PDF"
    },
    "types": {
      "delivery_note": "Δελτίο Αποστολής",
      "receipt": "ΑΛΠ",
      "receipt_with_delivery_note": "ΑΛΠ & Δ.Α.",
      "invoice": "Τιμολόγιο",
      "invoice_with_delivery_note": "Τιμολόγιο & Δ.Α.",
      "invoice_on_behalf": "Τιμολόγιο (τρίτων)",
      "clearance_invoice": "Εκκαθάριση (τρίτων)",
      "receipt_on_behalf": "ΑΛΠ (τρίτων)",
      "credit_invoice": "Πιστωτικό Τιμολόγιο",
      "retail_credit_note": "Πιστωτικό ΑΛΠ"
    },
    "status": {
      "success": "Επιτυχής",
      "failure": "Αποτυχία",
      "cancelled": "Ακυρώθηκε",
      "pending": "Εκκρεμεί"
    },
    "actions": {
      "viewPdf": "Προβολή PDF"
    },
    "documentsCount": {
      "one": "{count} έγγραφο",
      "other": "{count} έγγραφα"
    },
    "pagination": {
      "footer": "Σελίδα {page} από {totalPages} (Σύνολο: {count} παραγγελίες)"
    },
    "empty": {
      "title": "Δεν υπάρχουν υποβολές ακόμα",
      "description": "Το ιστορικό υποβολών myDATA θα εμφανιστεί εδώ μόλις υποβάλετε το πρώτο σας δελτίο αποστολής."
    }
  },
  "dashboard": {
    "subscription": {
      "title": "Πρόγραμμα Συνδρομής",
      "freeTrial": "Δωρεάν Δοκιμή",
      "basicPlan": "Comply Starter",
      "month": "μήνα",
      "docsPerMonth": "υποβολές/μήνα",
      "perDoc": "υποβολή",
      "popular": "Δημοφιλές",
      "needMore": "Χρειάζεστε περισσότερες υποβολές;",
      "confirmCancel": "Είστε σίγουροι ότι θέλετε να ακυρώσετε τη συνδρομή σας; Θα διατηρήσετε την πρόσβαση μέχρι το τέλος της περιόδου που έχετε ήδη πληρώσει.",
      "status": {
        "active": "Ενεργό",
        "cancelled": "Ακυρωμένο",
        "expired": "Έχει λήξει",
        "trial": "Δοκιμή"
      },
      "pricing": {
        "trial": "7 δωρεάν υποβολές",
        "monthly": "από €9.99 / μήνα"
      },
      "billingPeriod": "Ξεκίνησε στις",
      "actions": {
        "upgrade": "Αναβάθμιση",
        "cancel": "Ακύρωση Συνδρομής",
        "reactivate": "Επανενεργοποίηση Συνδρομής",
        "subscribe": "Εγγραφή",
        "select": "Επιλογή Πλάνου"
      },
      "cancelledBanner": "Η συνδρομή σας ακυρώθηκε. Θα έχετε πρόσβαση μέχρι τις {date}.",
      "trialInfo": "Οι δωρεάν υποβολές σας έχουν εξαντληθεί. Επιλέξτε ένα από τα μηνιαία προγράμματά μας για να συνεχίσετε.",
      "trialActive": "Βρίσκεστε στη δωρεάν δοκιμή. Τα προγράμματα θα εμφανιστούν εδώ όταν εξαντληθούν οι δωρεάν υποβολές σας.",
      "redirecting": "Ανακατεύθυνση στο Shopify για επιβεβαίωση...",
      "notifications": {
        "activated": "Η συνδρομή ενεργοποιήθηκε επιτυχώς!",
        "activationFailed": "Η ενεργοποίηση της συνδρομής απέτυχε. Παρακαλώ δοκιμάστε ξανά.",
        "declined": "Η συνδρομή απορρίφθηκε. Μπορείτε να δοκιμάσετε ξανά ανά πάσα στιγμή.",
        "cancelled": "Η συνδρομή ακυρώθηκε.",
        "couldNotInitiate": "Δεν ήταν δυνατή η έναρξη της διαδικασίας συνδρομής.",
        "couldNotCancel": "Δεν ήταν δυνατή η ακύρωση της συνδρομής.",
        "couldNotReactivate": "Δεν ήταν δυνατή η επανενεργοποίηση της συνδρομής.",
        "unknownError": "Παρουσιάστηκε άγνωστο σφάλμα."
      }
    },
    "quota": {
      "vipBanner": {
        "title": "✨ Είσαι σε καθεστώς VIP!",
        "body": "Το VIP κωδικός σου σου έδωσε {bonus} επιπλέον δωρεάν υποβολές — σύνολο {total} δωρεάν υποβολών αντί για 7!"
      },
      "title": {
        "trial": "Δωρεάν Υποβολές",
        "subscription": "Χρήση Συνδρομής"
      },
      "period": {
        "lifetime": "συνολικά",
        "monthly": "αυτόν τον μήνα"
      },
      "remaining": "{count} υπολειπόμενες",
      "remainingSingular": "{count} υπολειπόμενη",
      "noRemaining": "Καμία υπολειπόμενη",
      "resetsOn": "Επαναφορά: {date}",
      "trialInfo": "Οι πρώτες {limit} καλύπτονται δωρεάν"
    },
    "productUpdates": {
      "title": "Ενημερώσεις Προϊόντος",
      "comingSoon": "Σύντομα Διαθέσιμα",
      "whatsNew": "Τι Νέο Υπάρχει"
    },
    "currentVersion": {
      "title": "Τρέχουσα Έκδοση",
      "updatedOn": "Ενημερώθηκε στις {date}"
    },
    "feedback": {
      "title": "Βοηθήστε μας να βελτιωθούμε",
      "subtitle": "Βρήκατε κάποιο σφάλμα ή έχετε κάποια ερώτηση; Ενημερώστε μας και θα επικοινωνήσουμε μαζί σας εντός 24 ωρών.",
      "fields": {
        "type": {
          "label": "Τύπος",
          "options": {
            "bug": "🐛 Αναφορά Σφάλματος",
            "feature": "✨ Αίτημα Χαρακτηριστικού",
            "general": "💬 Γενικά Σχόλια"
          }
        },
        "title": {
          "label": "Τίτλος",
          "placeholder": "Σύντομη περίληψη"
        },
        "description": {
          "label": "Περιγραφή",
          "placeholder": "Δώστε λεπτομέρειες..."
        },
        "email": {
          "label": "Email (προαιρετικό)",
          "placeholder": "to-email-sas@example.com",
          "helpText": "Για επικοινωνία σχετικά με τα σχόλιά σας"
        }
      },
      "submit": "Υποβολή Σχολίων",
      "success": "Ευχαριστούμε για τα σχόλιά σας! Θα τα εξετάσουμε σύντομα.",
      "error": "{message}",
      "requiredError": "Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία"
    },
    "contact": {
      "title": "Χρειάζεστε βοήθεια;",
      "subtitle": "Είμαστε εδώ — καλέστε μας ή στείλτε email."
    }
  },
  "settings": {
    "title": "Ρυθμίσεις",
    "mydata": {
      "title": "Διαπιστευτήρια myDATA",
      "subtitle": "Συνδέστε τον λογαριασμό σας myDATA για αυτόματη υποβολή παραστατικών",
      "expand": "Ρυθμίσεις Απευθείας ΑΑΔΕ",
      "collapse": "Απόκρυψη",
      "guideTitle": "Πώς να αποκτήσετε τα διαπιστευτήρια myDATA API",
      "guideSteps": "Ακολουθήστε τα παρακάτω βήματα για να εγγραφείτε στο myDATA REST API:",
      "guideLink": "Οδηγός myDATA",
      "guideStep1Before": "Επισκεφθείτε τη ",
      "guideStep1Link": "σελίδα εγγραφής myDATA REST API της ΑΑΔΕ",
      "guideStep1After": " και συνδεθείτε με τους κωδικούς σας TaxisNet",
      "guideStep2Before": "Κάντε κλικ στο ",
      "guideStep2Button": "Εγγραφή στο myDATA REST API",
      "guideStep2After": "",
      "guideStep3Before": "Επιλέξτε ",
      "guideStep3Button": "Νέα εγγραφή χρήστη",
      "guideStep3After": "",
      "guideStep4": "Επιλέξτε ένα όνομα χρήστη — ιδανικά κάτι απλό, π.χ. \"mydatauser\" — και ολοκληρώστε την εγγραφή",
      "guideStep5Before": "Αντιγράψτε και αποθηκεύστε το ",
      "guideStep6Before": "Εισάγετε το όνομα χρήστη που επιλέξατε ως ",
      "guideStep6Middle": " και επικολλήστε το ",
      "guideStep6After": " στη φόρμα παρακάτω",
      "userId": {
        "label": "myDATA User ID",
        "helpText": "Το User ID σας από την ΑΑΔΕ",
        "placeholder": "π.χ. 123456789"
      },
      "subscriptionKey": {
        "label": "Subscription Key",
        "helpText": "Το API subscription key σας από την ΑΑΔΕ",
        "placeholder": "Εισάγετε το subscription key"
      },
      "environment": {
        "label": "Περιβάλλον",
        "sandbox": "Περιβάλλον Δοκιμών (mydataapidev.aade.gr)",
        "production": "Παραγωγικό Περιβάλλον (mydatapi.aade.gr)",
        "helpText": "Χρησιμοποιήστε το περιβάλλον δοκιμών για testing, το παραγωγικό για πραγματικές συναλλαγές"
      }
    },
    "vip": {
      "title": "Είσαι VIP! 🎉",
      "subtitle": "Έχεις κωδικό VIP; Εξαργύρωσέ τον εδώ για επιπλέον δωρεάν υποβολές.",
      "codeLabel": "Κωδικός VIP",
      "codePlaceholder": "Επικόλληση κωδικού",
      "apply": "Εξαργύρωση",
      "applying": "Εξαργύρωση...",
      "grantedBonus": "Έχεις ήδη {count} επιπλέον δωρεάν υποβολές από κωδικό VIP.",
      "successTitle": "Καλωσόρισες στους VIP!",
      "success": "Κερδίσατε {count} επιπλέον δωρεάν υποβολές. Σύνολο δωρεάν υποβολών: {total}."
    },
    "company": {
      "title": "Στοιχεία Επιχείρησης",
      "subtitle": "Αυτά τα στοιχεία θα εμφανίζονται στα παραστατικά σας",
      "vat": {
        "label": "ΑΦΜ",
        "helpText": "9ψήφιος ελληνικός ΑΦΜ (υποχρεωτικό)",
        "placeholder": "999999999"
      },
      "name": {
        "label": "Επωνυμία",
        "helpText": "Η καταχωρημένη επωνυμία της εταιρείας σας"
      },
      "address": {
        "label": "Διεύθυνση",
        "helpText": "Οδός και αριθμός"
      },
      "city": {
        "label": "Πόλη"
      },
      "postalCode": {
        "label": "Ταχυδρομικός Κώδικας",
        "helpText": "5ψήφιος ταχυδρομικός κώδικας",
        "placeholder": "12345"
      },
      "profession": {
        "label": "Επάγγελμα",
        "helpText": "π.χ. Λιανικό Εμπόριο",
        "placeholder": "Λιανικό Εμπόριο"
      },
      "taxOffice": {
        "label": "ΔΟΥ",
        "helpText": "π.χ. Α΄ Αθηνών",
        "placeholder": "Α΄ Αθηνών"
      },
      "gemi": {
        "label": "ΓΕΜΗ",
        "helpText": "Προαιρετικό. Εμφανίζεται στα PDF παραστατικά"
      },
      "phone": {
        "label": "Τηλέφωνο",
        "helpText": "Εμφανίζεται στα PDF παραστατικά",
        "placeholder": "210 1234567"
      },
      "email": {
        "label": "Email",
        "helpText": "Εμφανίζεται στα PDF παραστατικά",
        "placeholder": "info@example.gr"
      },
      "logo": {
        "label": "URL Λογότυπου Εταιρείας",
        "helpText": "URL της εικόνας του λογότυπου της εταιρείας σας (θα εμφανίζεται στα PDF)",
        "placeholder": "https://cdn.shopify.com/s/files/1/xxxx/logo.png",
        "guideTitle": "Πώς να πάρετε το URL του λογότυπου σας από το Shopify:",
        "guideIntro": "Ακολουθήστε αυτά τα βήματα για να ανεβάσετε και να πάρετε το URL του λογότυπου της εταιρείας σας:",
        "guideStep1": "Πηγαίνετε στο Shopify Admin →",
        "guideStep1Link": "Ρυθμίσεις → Αρχεία",
        "guideStep2": "Κάντε κλικ στο 'Ανέβασμα αρχείων' και επιλέξτε το λογότυπο της εταιρείας σας (συνιστάται μορφή PNG, JPG ή SVG)",
        "guideStep3": "Μετά το ανέβασμα, κάντε κλικ στο αρχείο του λογότυπου σας στη λίστα",
        "guideStep4": "Κάντε κλικ στο κουμπί 'Αντιγραφή συνδέσμου' ή κάντε δεξί κλικ στην προεπισκόπηση και αντιγράψτε το URL της εικόνας",
        "guideTip": "Συμβουλή: Το URL πρέπει να μοιάζει με https://cdn.shopify.com/s/files/... και να είναι δημόσια προσβάσιμο"
      },
      "defaultVatRate": {
        "label": "Προεπιλεγμένος Συντελεστής ΦΠΑ",
        "helpText": "Θα χρησιμοποιηθεί όταν το Shopify δεν έχει ρυθμισμένο ΦΠΑ στα προϊόντα σας. Επιλέξτε τον συντελεστή που ισχύει για τα περισσότερα προϊόντα σας."
      }
    },
    "vatSchemes": {
      "title": "Υποστηριζόμενα Καθεστώτα ΦΠΑ",
      "subtitle": "Ενεργοποιήστε τα καθεστώτα OSS/IOSS για τα οποία είναι εγγεγραμμένη η επιχείρησή σας. Όλες οι επιλογές είναι απενεργοποιημένες εξ ορισμού — ενεργοποιήστε μόνο όταν έχετε ολοκληρώσει την αντίστοιχη εγγραφή στην ΑΑΔΕ και στο Shopify.",
      "ossEu": {
        "label": "OSS ΕΕ (Καθεστώς Ενωσιού — ενδοκοινοτικές πωλήσεις από ιδιώτες)",
        "description": "Για ελληνικές επιχειρήσεις που πωλούν αποκλειστικά σε πελάτες σε άλλες χώρες της ΕΕ. Όταν ενεργοποιηθεί, οι παραγγελίες με προορισμό εντός ΕΕ υποβάλλονται με μηδενικό ελληνικό ΦΠΑ (εξαίρεση άρθρο 57) και τη βέλτιστη ταξινόμηση εσόδων για λιανικές πωλήσεις ΕΕ.",
        "callout": "Βεβαιωθείτε ότι είστε εγγεγραμμένοι στο Καθεστώς OSS (Ενωσικό Σύστημα) μέσω ΑΑΔΕ και ότι έχετε ενεργοποιήσει την εισπραξη ΦΠΑ ΕΕ στις Ρυθμίσεις Φόρου του Shopify. Χωρίς αμφότερα, η ενεργοποίηση αυτής της επιλογής θα παράγει λανθασμένα παραστατικά."
      },
      "ossNonEu": {
        "label": "Εξαγωγές εκτός ΕΕ (μηδενικός συντελεστής ΦΠΑ)",
        "description": "Για παραγγελίες προς χώρες εκτός Ευρωπαϊκής Ένωσης. Όταν ενεργοποιηθεί, οι εξαγωγές υποβάλλονται με μηδενικό ΦΠΑ (εξαιρέσεις άρθρο 56) και ταξινόμηση εξαγωγών (E3_561_005).",
        "callout": "Ενεργοποιήστε μόνο εάν οι παραγγελίες σας προς χώρες εκτός ΕΕ απαλλάσσονται από τον ΦΠΑ βάσει ελληνικού νόμου. Επιβεβαιωθείτε με τον λογιστή σας πριν απο την ενεργοποίηση."
      },
      "ioss": {
        "label": "IOSS (Import One Stop Shop)",
        "description": "Για αγαθά που αποστέλλονται από τρίτες χώρες σε καταναλωτές εντός ΕΕ, αξίας έως 150€. Απαιτεί ξεχωριστό αριθμό IOSS.",
        "notSupported": "Η υποστήριξη IOSS δεν είναι ακόμα διαθέσιμη. Αυτή η επιλογή θα ενεργοποιηθεί σε μελλοντική ενημέρωση."
      }
    },
    "actions": {
      "save": "Αποθήκευση Ρυθμίσεων",
      "test": "Δοκιμή Σύνδεσης"
    },
    "notifications": {
      "saveSuccess": "Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς",
      "saveFailed": "Αποτυχία αποθήκευσης ρυθμίσεων",
      "testSuccess": "Η σύνδεση myDATA ήταν επιτυχής!",
      "testFailed": "Η δοκιμή σύνδεσης απέτυχε",
      "loadFailed": "Αποτυχία φόρτωσης ρυθμίσεων",
      "error": "Προέκυψε σφάλμα",
      "bannerSuccess": "Επιτυχία",
      "bannerError": "Σφάλμα"
    }
  },
  "footer": {
    "copyright": "© 2026 myDATA Comply. Με την επιφύλαξη παντός δικαιώματος.",
    "version": "έκδ. 1.0.0",
    "privacy": "Πολιτική Απορρήτου",
    "terms": "Όροι Χρήσης",
    "support": "Υποστήριξη",
    "documentation": "Τεκμηρίωση"
  },
  "common": {
    "close": "Κλείσιμο"
  },
  "contractStatus": {
    "title": "Σύμβαση Παρόχου",
    "providerActive": "Ο πάροχος είναι ενεργός",
    "providerInactive": "Ο πάροχος δεν είναι ενεργός ακόμη",
    "unsigned": {
      "title": "Δεν έχετε υπογράψει τη σύμβαση",
      "description": "Για να ενεργοποιηθεί ο πάροχος πρέπει να υπογράψετε ψηφιακά τη σύμβαση και να την κατεβάσετε.",
      "signButton": "Υπογράψτε τη σύμβαση ↗",
      "downloadButton": "Κατεβάστε τη σύμβαση"
    },
    "stale": {
      "title": "Τα στοιχεία σας άλλαξαν μετά την υπογραφή",
      "description": "Η υπογεγραμμένη σύμβαση δεν αντιστοιχεί πλέον στα τρέχοντα στοιχεία σας. Ενημερώστε τα στοιχεία και υπογράψτε ξανά τη σύμβαση.",
      "resignButton": "Υπογράψτε ξανά ↗",
      "downloadPreviousButton": "Λήψη προηγούμενης υπογεγραμμένης"
    },
    "signed": {
      "title": "Η σύμβαση έχει υπογραφεί",
      "description": "Η σύμβασή σας είναι υπογεγραμμένη και ο λογαριασμός παρόχου σας είναι ενεργός.",
      "downloadButton": "Λήψη υπογεγραμμένης σύμβασης"
    },
    "pending": {
      "title": "Σύμβαση παρελήφθη — εκκρεμεί ενεργοποίηση",
      "description": "Λάβαμε την υπογεγραμμένη σύμβασή σας και ενεργοποιούμε τον λογαριασμό παρόχου. Αυτό συνήθως διαρκεί 1–2 εργάσιμες ημέρες. Στο μεταξύ, παρακαλούμε ακολουθήστε τον οδηγό εγγραφής παρόχου στην ΑΑΔΕ που σας στείλαμε στο email σας — θα χρειαστεί να ολοκληρώσετε αυτό το βήμα για να μπορέσετε να υποβάλετε παραστατικά."
    }
  },
  "onboarding": {
    "loading": "Φόρτωση...",
    "help": {
      "title": "Χρειάζεστε βοήθεια;",
      "subtitle": "Είμαστε εδώ κατά την εγγραφή — καλέστε μας ή στείλτε email.",
      "phone": "698 359 6733",
      "email": "lefteris@weam.gr"
    },
    "title": "Εγγραφή Παρόχου",
    "step": "Βήμα {step} / 2",
    "welcome": {
      "title": "🎉 Ευχαριστούμε που εγκαταστήσατε το myDATA Comply!",
      "subtitle": "Πριν ξεκινήσετε τις υποβολές, χρειαζόμαστε λίγα στοιχεία της επιχείρησής σας για να δημιουργήσουμε τη σύμβαση παρόχου.",
      "durationBold": "~2 λεπτά",
      "durationText": "Η διαδικασία παίρνει μόνο {duration} — συμπληρώνετε μια σύντομη φόρμα και υπογράφετε ψηφιακά τη σύμβαση.",
      "startButton": "Ξεκινήστε την εγγραφή →"
    },
    "form": {
      "banner": "Συμπληρώστε τα στοιχεία σας για τη δημιουργία της σύμβασης παρόχου. Μετά την υποβολή θα λάβετε τη σύμβαση για ψηφιακή υπογραφή.",
      "continueButton": "Συνέχεια →"
    },
    "signing": {
      "title": "Υπογραφή Σύμβασης",
      "description": "Η σύμβαση παρόχου σας είναι έτοιμη. Ανοίξτε την σε νέα καρτέλα για να ελέγξετε τα στοιχεία και να υπογράψετε ψηφιακά — η διαδικασία διαρκεί περίπου 2 λεπτά.",
      "signButton": "Άνοιγμα & Υπογραφή ↗",
      "openNote": "Μετά την υπογραφή, επιστρέψτε εδώ και πατήστε παρακάτω για να συνεχίσετε στο dashboard.",
      "skipButton": "Θα υπογράψω αργότερα →",
      "pendingTitle": "Αναμονή Υπογραφής",
      "pendingDescription": "Η σύμβασή σας έχει αποσταλεί στο email σας. Ακολουθήστε τον σύνδεσμο υπογραφής για να ολοκληρώσετε τη διαδικασία.",
      "activationNote": "Μετά την υπογραφή και την έγκριση, ο λογαριασμός σας θα ενεργοποιηθεί εντός 1–2 εργάσιμων ημερών. Παρακολουθήστε την κατάσταση από το dashboard.",
      "continueDashboardButton": "Μετάβαση στο Dashboard →",
      "signedTitle": "Η Σύμβαση Υπογράφηκε ✓",
      "signedDescription": "Η σύμβασή σας υπογράφηκε. Σας μεταφέρουμε στο dashboard…",
      "waitingLabel": "Αναμένοντας την υπογραφή…"
    },
    "errors": {
      "submitFailed": "Αποτυχία υποβολής φόρμας",
      "networkError": "Σφάλμα δικτύου",
      "sessionExpired": "Η σύνδεση έληξε. Ανανέωση σελίδας...",
      "completeFailed": "Αποτυχία ενημέρωσης κατάστασης"
    }
  },
  "contractForm": {
    "section": {
      "companyDetails": "Στοιχεία Εταιρείας",
      "representative": "Νόμιμος Εκπρόσωπος",
      "contact": "Στοιχεία Επικοινωνίας",
      "serviceType": "Τύπος Υπηρεσίας Τιμολόγησης",
      "altProvider": "Πάροχος Επικοινωνίας"
    },
    "fields": {
      "officialName": "Πλήρης Επωνυμία",
      "tradingName": "Διακριτικός Τίτλος",
      "vatNumber": "ΑΦΜ Εταιρείας",
      "taxOffice": "ΔΟΥ",
      "profession": "Επάγγελμα",
      "professionPlaceholder": "Λιανικό Εμπόριο",
      "address": "Διεύθυνση",
      "city": "Πόλη",
      "postalCode": "Τ.Κ.",
      "representativeName": "Ονοματεπώνυμο Εκπροσώπου",
      "representativeVat": "ΑΦΜ Εκπροσώπου",
      "contactEmail": "Email Επικοινωνίας",
      "contactEmailHelp": "Σε αυτό το email θα λάβετε τις οδηγίες ενεργοποίησης του παρόχου από την πλευρά μας μετά την υπογραφή της σύμβασης.",
      "phone": "Τηλέφωνο",
      "serviceTypeLabel": "Τύπος",
      "serviceTypes": {
        "b2b": "B2B (Τιμολόγηση επιχειρήσεων)",
        "b2c": "B2C (Λιανική)",
        "b2b_and_b2c": "B2B & B2C (Και τα δύο)"
      },
      "b2cBannerTitle": "Απαίτηση νόμου για B2C/λιανική:",
      "b2cBannerBody": "Για την έκδοση αποδείξεων λιανικής μέσω myDATA, ο νόμος υποχρεώνει να διαθέτετε ενεργό συμβόλαιο με έναν εγκεκριμένο πάροχο επικοινωνίας (π.χ. COSMOTE, VODAFONE, NOVA). Παρακαλώ συμπληρώστε τα στοιχεία του παρόχου με τον οποίο έχετε συμβόλαιο ακριβώς όπως αναγράφονται σε αυτό.",
      "altProviderName": "Επωνυμία",
      "altProviderNameHelp": "π.χ. COSMOTE, VODAFONE, NOVA",
      "altProviderNr": "Αριθμός Σύμβασης",
      "altProviderNrHelp": "Όπως αναγράφεται στο συμβόλαιό σας",
      "altProviderDate": "Ημερομηνία Σύμβασης",
      "altProviderDateHelp": "Ημερομηνία έναρξης συμβολαίου",
      "requiredB2c": "Υποχρεωτικό για B2C"
    }
  },
  "validation": {
    "required": "Υποχρεωτικό πεδίο",
    "vatLength": "Απαιτείται 9ψήφιο ΑΦΜ",
    "emailInvalid": "Απαιτείται έγκυρο email"
  }
}